/* eslint-disable @typescript-eslint/no-explicit-any */

function extraIosSteps(): boolean {
  const htmlEl = document.getElementsByTagName('html')[0];
  const bodyEl = document.getElementsByTagName('body')[0];

  const oldHtmlHeight = htmlEl.style.height;
  const oldBodyHeight = bodyEl.style.height;

  htmlEl.style.height = '100vh';
  bodyEl.style.height = '100%';

  const webViewMode =
    document.documentElement.clientHeight === document.documentElement.scrollHeight;

  // restore height
  htmlEl.style.height = oldHtmlHeight;
  bodyEl.style.height = oldBodyHeight;

  return webViewMode;
}

export function detectWebView(): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { standalone } = window.navigator as any;
  const userAgent = window.navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);

  let isWebView = false;

  if (ios) {
    if (!standalone && !safari) {
      // iOS webview
      isWebView = true;
    }

    if (!isWebView) isWebView = extraIosSteps();
  } else if (userAgent.includes('wv')) {
    // Android webview
    isWebView = true;
  } else if (Object.prototype.hasOwnProperty.call(window, 'Android ')) {
    isWebView = true;
  } else if (typeof (window as any).Android !== 'undefined') {
    isWebView = true;
  }

  return isWebView;
}
